<template>
  <div class="block-wrap block-std-size-extends" style="padding-top: 8px">
    <SelectSizeTemp class="ml-5" ref="selectSizeTempRef" :sizeNameKey="sizeNameKey" @updateSizeMappings="updateSpecSizeMappings" @getSizeMappingsData="getSpecSizeMappings" />
    <div class="size-select-list">
      <label class="label"
        >选择参数(<span style="color: #f56c6c">{{ selectedNames.length }}</span> / {{ sizeMappings.length }}):</label
      >
      <el-checkbox-group v-model="selectedNames" class="checkbox-group" @change="selectedNamesChange">
        <template v-for="item in sizeMappings">
          <el-checkbox :key="item.name" :label="item.name"> {{ item.label }}</el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
    <div class="sell-custom">
      <div class="sell-custom-tips" style="">自定义项无法输入数字和特殊字符，且最多只能输入4个汉字，8个字符</div>
      <div>
        <el-button @click="addCustomSize"> <el-link :underline="false">+自定义</el-link></el-button>
        <template v-for="(item, idx) in customSizes">
          <span :key="item.name" class="custom-item">
            <el-input
              v-model="item.label"
              width="150px"
              regexp="^[\u4e00-\u9fa5]{0,4}$|^[a-zA-Z]{0,8}$"
              @change="customSizeChange(item, idx)"
            >
              <template slot="append">cm</template>
            </el-input>
            <el-button @click="deleteCustomSize(item, idx)" style="color: #666" type="link" icon="el-icon-delete"></el-button>
          </span>
        </template>
      </div>
    </div>

    <el-table height="300px" :data="list" :key="tablekey">
      <el-table-column width="120px" fixed="left" key="sizeName" prop="sizeName" :label="stdSizeProp.name"> </el-table-column>
      <el-table-column v-for="col in tableCols" :key="col.prop" :prop="col.prop" v-bind="col.attrs">
        <template slot="header">
          <span v-if="col.required" style="color: red">*</span>
          {{ col.label }}
          <el-button type="text" @click="switchValueType(col)" style="padding: 0">
            <i class="el-icon-swap"></i> {{ col.isRange ? '值' : '区间' }}
          </el-button>
        </template>
        <template slot-scope="{ row }">
          <template v-if="row.isShow">
            <el-form-item :inline-message="true" :error="row[`${col.prop}Error`]">
              <template v-if="col.isRange">
                <el-input-digit
                  v-model.number="row[col.prop].valueStart"
                  placeholder="最小值"
                  :nullable="true"
                  v-bind="col.input.attrs"
                  style="width: 60px"
                  @input="onInput(row, col.prop)"
                />
                -
                <el-input-digit
                  v-model.number="row[col.prop].valueEnd"
                  placeholder="最大值"
                  :nullable="true"
                  v-bind="col.input.attrs"
                  style="width: 60px"
                  @input="onInput(row, col.prop)"
                />
              </template>
              <el-input-digit
                v-else
                v-model.number="row[col.prop].valueStart"
                :nullable="true"
                v-bind="col.input.attrs"
                @input="onInput(row, col.prop)"
              />
            </el-form-item>
          </template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" key="operate" prop="operate" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" @click="clearItem(row)">清空</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { genIsShowFn } from '../../utils/disableRule';
import {getSizeMapping} from '@servers/prod/center/index.js'
import SelectSizeTemp from './SelectSizeTemp.vue'
import storeMixins from '../store-mixins'
import _,{ cloneDeep } from 'lodash';

export default {
  mixins: [storeMixins],
  components: {SelectSizeTemp},
  inject: {
    tbFormVm: {
      default: {}
    },
    openSource:{default:null},
    sizeGroupObj:{default:{}},
  },
  props: {
    specifications: {
      type: Array,
      default() {
        return [];
      },
    },
    schema: {
      type: Array,
      default() {
        return [];
      },
    },
    sizeNameKey: {
      type: String,
      default: '',
    },    
    isSizeMapRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sizeMappings: [],
      extendSize:null,
      sizeMappingLoading: false,
      sizeMappingPromise: null,
      selectedNames: [],
      customSizes: [],
      list: [],
      tableCols: [],
      inputRules: {},
      stdSizeProp: {},
      valueMaps: {},
      tablekey: 1,
    };
  },
  watch: {
    // schema: {
    //   handler(v) {
    //     this.init();
    //   },
    //   immediate: true,
    // },
    specifications: {
      handler() {
        this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {},
  methods: {
    async init() {
      if (!this.schema.length || !this.specifications) return;
      this.initSchemaSizeMappings();
      await this.initSpecSizeMappings();
      this.updateTableCols();
      this.initList();
    },
    initSchemaSizeMappings() {
      const sizeMappings = [];
      const sizeRequireMappings = [];
      this.schema.forEach(item => {
        genIsShowFn(item);
        if (item.rules?.requiredRule === 'true') {
          sizeRequireMappings.push(item);
        } else {
          sizeMappings.push(item);
        }
      });
      this.sizeMappings = sizeMappings;
      this.sizeRequireMappings = sizeRequireMappings;
    },
    async initSpecSizeMappings() {
      let stdSizeProp = this.specifications.find(item => this.sizeNameKey.includes(item.nameKey));
      if (!stdSizeProp) return;
      let extendValues = stdSizeProp?.values?.find(item => item.extendValues)?.extendValues || this.extendSize || {};
      // sizeMapping 不是尺码表数据字段，过滤掉
      let sizeMappingKeys = Object.keys(extendValues).filter(key => key !== 'sizeMapping');
      if (this.openSource !== 'shopGoods' && (_.isEmpty(extendValues) || sizeMappingKeys.length === 0)) {
        // 没有尺码表数据就请求接口获取一下然后填充
        let _specifications = await this.getSizeMappingData();
        if (_specifications) {
          try {
            _specifications = JSON.parse(_specifications);
          } catch (e) {}
          stdSizeProp = _specifications.find(item => this.sizeNameKey.includes(item.nameKey));
          if (!stdSizeProp) return;
          extendValues = stdSizeProp?.values[0]?.extendValues || {};
          this.extendSize = extendValues;
        }
      }
      const selectedNames = [];
      const customSizes = [];
      Object.keys(extendValues).forEach(n => {
        if (extendValues[n] instanceof Object && !this.sizeRequireMappings.find(size => size.name === n)) {
          if (this.sizeMappings.find(size => size.name === n)) {
            selectedNames.push(n);
          } else {
            customSizes.push({
              ...extendValues[n],
              name: n,
              label: (extendValues[n].defaultValue || '').replace('（cm）', ''),
            });
          }
        }
      });
      this.selectedNames = selectedNames;
      this.customSizes = customSizes;
      this.$set(this, 'stdSizeProp', stdSizeProp);
    },
    updateSpecSizeMappings(data){
      let stdSizeProp = {...data.sizeDetail};
      (stdSizeProp?.values || []).forEach(item => {
        item.checked = true
      });
      let extendValues = stdSizeProp?.values[0]?.extendValues || this.extendSize || {};
      const selectedNames = [];
      const customSizes = [];
      let sizeGroupKey = this.sizeGroupObj.name;
      Object.keys(extendValues).forEach(n => {
        if (extendValues[n] instanceof Object && !this.sizeRequireMappings.find(size => size.name === n)) {
          if (this.sizeMappings.find(size => size.name === n)) {
            selectedNames.push(n);
          } else {
            customSizes.push({
              ...extendValues[n],
              name: n,
              label: (extendValues[n].defaultValue || '').replace('（cm）', ''),
            });
          }
        }
      });
      this.selectedNames = selectedNames;
      this.customSizes = customSizes;
      this.$set(this, 'list', []);
      this.$set(this, 'stdSizeProp', stdSizeProp);
      let sizeGroupOpt = this.$refs.selectSizeTempRef?.getOptions() || [];
      if(sizeGroupOpt.length && sizeGroupOpt.find(item => item.value === data.sizeGroup)) { // 尺码分组存在这个选项就回显，否则不回显
        this.$set(this.tbForm,sizeGroupKey, data.sizeGroup); // 尺码分组回显
      }
      this.getSpecSizeMappings(stdSizeProp);
    },
    getSpecSizeMappings(stdSizeProp,cb){
      let tableList = [];
      let colList = [];
      let selectedNames = this.selectedNames || [];
      let customSizes = this.customSizes || [];
      let extendValues = stdSizeProp?.values[0]?.extendValues;
      if(cb){
        selectedNames = []
        customSizes = []
        Object.keys(extendValues).forEach(n => {
          if (extendValues[n] instanceof Object && !this.sizeRequireMappings.find(size => size.name === n)) {
            if (this.sizeMappings.find(size => size.name === n)) {
              selectedNames.push(n);
            } else {
              customSizes.push({
                ...extendValues[n],
                name: n,
                label: (extendValues[n].defaultValue || '').replace('（cm）', ''),
              });
            }
          }
        });
      }
      function getColList(that){
        that.sizeRequireMappings.forEach(item => {
          colList.push(that.getColItem(item));
        });
        selectedNames.forEach(name => {
          const requireItem = that.sizeRequireMappings.find(size => size.name === name);
          if (requireItem) return;
          const item = that.sizeMappings.find(size => size.name === name);
          item && colList.push(that.getColItem(item, { required: false }));
        });
        customSizes.forEach(custom => {
          custom.label && colList.push(that.getColItem(custom, { required: false }));
        });
      }
      function getTableList(that){
        stdSizeProp.values.map(item => {
          if (item.value && item.checked) {
            const extendValues = item.extendValues || {};
            const tableItem = {
              sizeValue: item.value,
              sizeName: item.value,
            };

            // 处理用于展示的规格值
            if (stdSizeProp.formType === 'select') {
              // 此规格是下拉框类型的需要寻找options里对应的displayName
              tableItem.sizeName = stdSizeProp.options.find(op => op.value === item.value)?.displayName || item.value || '未知';
            }
            const findItem = tableList.find(row => row.sizeValue === tableItem.sizeValue) || {}
            colList.forEach(col => {
              tableItem[col.prop] = findItem[col.prop] || { ...tableItem[col.prop], ...extendValues[col.prop] };
              tableItem.isShow = col.isShowFn ? col.isShowFn({ [item.nameKey]: item.value }) : true;
            });
            that.sizeMappings.forEach(mapping => {
              if (!tableItem[mapping.name]) {
                tableItem[mapping.name] = {
                  valueStart: '',
                  valueEnd: '',
                  defaultValue: mapping.name,
                };
              }
            });

            tableList.push(tableItem);
          }
        });
        colList.forEach(col => {
          col.isRange = tableList.some(item => {
            return item[col.prop]?.valueEnd;
          });
        });
      }
      getColList(this)
      getTableList(this)
      if(cb){
        cb({colList,tableList})
        return
      }
      this.$set(this, 'tableCols', colList);
      this.$set(this, 'list', tableList);
    },
    getColItem(item, extend) {
      const oldItem = this.tableCols.find(old => old.prop === item.name) || {};
      const newItem = {
        prop: item.name,
        label: item.defaultValue || item.label,
        isShowFn: item.isShowFn,
        required: true,
        isRange: undefined,
        attrs: {
          width: '160px',
        },
        input: {
          attrs: {
            width: '90%',
            precision: 2,
          },
          custom_validator: this._geninputRules(item.name, item.rules),
        },
        ...extend,
      };
      return newItem;
    },
    updateTableCols() {
      const colList = [];
      this.sizeRequireMappings.forEach(item => {
        colList.push(this.getColItem(item));
      });
      this.selectedNames.forEach(name => {
        const requireItem = this.sizeRequireMappings.find(size => size.name === name);
        if (requireItem) return;
        const item = this.sizeMappings.find(size => size.name === name);
        item && colList.push(this.getColItem(item, { required: false }));
      });

      this.customSizes.forEach(custom => {
        custom.label && colList.push(this.getColItem(custom, { required: false }));
      });
      this.$set(this, 'tableCols', colList);
      this.tablekey++;
    },
    initList() {
      const list = [];
      if (!this.stdSizeProp?.name || !this.stdSizeProp.values?.length) {
        return [];
      }
      this.stdSizeProp.values.map(item => {
        if (item.value && item.checked) {
          const extendValues = item.extendValues || {};
          const tableItem = {
            sizeValue: item.value,
            sizeName: item.value,
          };

          // 处理用于展示的规格值
          if (this.stdSizeProp.formType === 'select') {
            // 此规格是下拉框类型的需要寻找options里对应的displayName
            tableItem.sizeName = this.stdSizeProp.options.find(op => op.value === item.value)?.displayName || item.value || '未知';
          }
          const findItem = this.list.find(row => row.sizeValue === tableItem.sizeValue) || {}
          this.tableCols.forEach(col => {
            tableItem[col.prop] = findItem[col.prop] || { ...tableItem[col.prop], ...extendValues[col.prop] };
            tableItem.isShow = col.isShowFn ? col.isShowFn({ [item.nameKey]: item.value }) : true;
          });
          this.sizeMappings.forEach(mapping => {
            if (!tableItem[mapping.name]) {
              tableItem[mapping.name] = {
                valueStart: '',
                valueEnd: '',
                defaultValue: mapping.name,
              };
            }
          });

          list.push(tableItem);
        }
      });
      this.$set(this, 'list', list);

      this.tableCols.forEach(col => {
        col.isRange = this.list.some(item => {
          return item[col.prop]?.valueEnd;
        });
      });
    },
    selectedNamesChange() {
      this.updateTableCols();
      this.initList();
    },
    customSizeChange(item) {
      item.defaultValue = item.label + '（cm）';
      this.updateTableCols();
      this.initList();
    },
    addCustomSize() {
      let customIndex = -1;
      const getCustomIndex = () => {
        const indexs = this.customSizes.map(item => Number(item.name.replace('sizeMapping_', '')));
        if (indexs.includes(customIndex)) {
          customIndex--;
          return getCustomIndex();
        } else {
          return customIndex;
        }
      };
      const name = 'sizeMapping_' + getCustomIndex();
      this.list.forEach(item => {
        item[name] = {
          defaultValue: name,
          valueStart: '',
        };
      });
      this.customSizes.push({
        name,
        label: '',
        defaultValue: '（cm）',
      });
    },

    deleteCustomSize(item, idx) {
      this.customSizes.splice(idx, 1);
      const findIdex = this.tableCols.findIndex(col => col.prop === item.name);
      this.tableCols.splice(findIdex, 1);
    },

    method_getStdSizeData() {
      const data = {};
      this.list.forEach(item => {
        let itemData = {};
        this.tableCols.forEach(col => {
          const { valueStart, valueEnd } = item[col.prop] || {};
          itemData[col.prop] = { valueStart: valueStart ? String(valueStart) : '', defaultValue: col.label };
          if (col.isRange) {
            itemData[col.prop].valueEnd = valueEnd ? String(valueEnd) : '';
          }
        });
        const sizeValue = item.sizeValue;
        data[sizeValue] = itemData;
      });
      return data;
    },
    // 校验
    validateStdList() {
      if(this.isSizeMapRequired && !this.tableCols.length) {
        return '尺码表至少选择一个参数'
      }
      // 校验空值
      const validateVoid = (value, prop) => {
        if (value === '' || value === undefined) {
          return `${prop.label}请勿输入空值`;
        }
        return false;
      };
      // 需要校验的props
      const props = this.tableCols.map(item => {
        let validator = item.input.validator || (item.required ? validateVoid : null);
        let newitem = {
          ...item,
          prop: item.prop,
          label: item.label,
          validator,
        };
        if (item.input.custom_validator) {
          delete newitem.validator;
          newitem.custom_validator = item.input.custom_validator;
        }
        return newitem;
      });
      let errmsg = '';
      for (let index = 0; index < this.list.length; index++) {
        const item = this.list[index];
        for (let pidex = 0; pidex < props.length; pidex++) {
          const prop = props[pidex];
          if (prop.custom_validator) {
            const custom_pass = prop.custom_validator(item, prop.prop);
            if (!custom_pass) {
              errmsg = '请完善尺码表明细';
            }
          } else if (prop.validator) {
            errmsg = prop.validator(item[prop.prop], prop);
          }
        }
      }
      if (errmsg) {
        // this.$message.error('请完善尺码表明细');
        return errmsg;
      }
      return true;
    },
    clearItem(tableItem) {
      this.tableCols.forEach(col => {
        tableItem[col.prop].valueStart = '';
        if (tableItem[col.prop].valueEnd) {
          tableItem[col.prop].valueEnd = '';
        }
      });
    },
    switchValueType(item) {
      item.isRange = !item.isRange;
      this.tablekey++
    },
    _geninputRules(prop, rules) {
      const { maxValueRule, requiredRule, regexRule } = rules || {};

      const validator = row => {
        const checkValue = _value => {
          if (requiredRule === 'true') {
            if (!_value && _value !== 0) {
              row[`${prop}Error`] = `必填`;
              return false;
            }
          }

          if (regexRule) {
            let reg = new RegExp(`^${regexRule}$`);
            if (!reg.test(_value)) {
              row[`${prop}Error`] = `请填入正确的格式：${regexRule}`;
              return false;
            }
          }
          if (maxValueRule) {
            if (Number(_value) > Number(maxValueRule)) {
              row[`${prop}Error`] = `最大值：${maxValueRule}`;
              return false;
            }
          }
          row[`${prop}Error`] = '';
          return true;
        };
        const isRange = this.tableCols.find(col => col.prop === prop)?.isRange;
        const { valueStart, valueEnd } = row[prop] || {};
        if (isRange) {
          return checkValue(valueStart) && checkValue(valueStart);
        } else {
          return checkValue(valueStart);
        }
      };
      this.inputRules[prop] = validator;
      return validator;
    },
    onInput(row, field) {
      this.inputRules[field] && this.inputRules[field](row);
      this.$emit('fieldChanged');
    },
    async getSizeMappingData(){
      const { self_form,form,categoryId } = this.tbFormVm;
      if(this.sizeMappingLoading) return
      const shopId = self_form.shopId || this.tbFormVm.shops_defaultShopId('tb')
      let params = {
        baseItemId:form.baseItemId,
        platformType:'tb',
        catId:categoryId,
        shopId,
        platformSpecifications:JSON.stringify(this.specifications),
      }
      this.sizeMappingLoading = true;
      let res = await getSizeMapping(params)
      this.sizeMappingLoading = false;
      return res;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #dcdfe6;
}
.block-std-size-extends {
  ::v-deep .cell {
    overflow: visible;
    padding: 5px;
  }
}
.size-select-list {
  display: flex;
  background: #f9f5f5;
  margin: 5px;
  padding: 10px;
  border-radius: 8px;
  .label {
    width: 120px;
    text-align: right;
  }
  .checkbox-group {
    padding: 0px 10px 10px;
    flex: 1;
  }
}
.sell-custom {
  background: #f9f5f5;
  margin: 5px;
  padding: 10px;
  border-radius: 8px;
  .sell-custom-tips {
    padding-bottom: 5px;
    color: #999;
    font-size: 12px;
  }
  .custom-item {
    margin-left: 10px;
  }
}
</style>